import React, { useState, useEffect } from "react";
import { Divider, Skeleton, Avatar, Space, Row, Col } from "antd";
import { UserOutlined, SettingOutlined } from "@ant-design/icons";
import { gql, useLazyQuery } from "@apollo/client";
import moment from "moment-jalaali";
import SideIncomesForm from "./form";

const GETINCOME = gql`
  query ($id: ID!) {
    getIncome(id: $id) {
      createdAt
      updatedAt
      documentImg
      amount
      description
      occurrenceAt
    }
  }
`;

function SideIncomesTableDetails({ id, onCloseDrawer, onDataUpdate }) {
  const [initialData, setInitialData] = useState({});

  const [formData, setFromData] = useState(null);

  const [getIncomeData, incomesData] = useLazyQuery(
    GETINCOME,
    {
      fetchPolicy: "no-cache",
      onCompleted({ getIncome }) {
        const incomesData = {
          occurrenceAt:
            getIncome?.occurrenceAt &&
            moment(getIncome?.occurrenceAt),
          amount: getIncome?.amount,
          description: getIncome?.description,
          documentImg : getIncome?.documentImg
        };
        setFromData(incomesData);
        const { description, createdAt, updatedAt, occurrenceAt, amount } =
          getIncome;
        setInitialData({
          description,
          amount,
          createdAt: createdAt && moment(createdAt).format("jYYYY/jMM/jDD"),
          updatedAt: updatedAt && moment(updatedAt).format("jYYYY/jMM/jDD"),
          occurrenceAt:
            occurrenceAt && moment(occurrenceAt).format("jYYYY/jMM/jDD"),
        });
      },
    }
  );
  useEffect(() => {
    if (id) {
      getIncomeData({
        variables: {
          id,
        },
      });
    }
  }, [id]);

  const incomesDataUpdated = () => {
    getIncomeData({
      variables: {
        id,
      },
    });
  };

  const { createdAt, updatedAt } = initialData;

  if (incomesData.loading)
    return (
      <>
        <Skeleton active round />
        <br />
        <Skeleton active round />
      </>
    );

  return (
    <>
      <Divider style={{ fontWeight: 700 }} orientation="right">
        اطلاعات درآمد
      </Divider>
      <Row>
        <Col sm={12} xs={24}>
          <Space align="">
            <p>تاریخ ثبت: </p>
            {createdAt}
          </Space>
        </Col>
        <Col sm={12} xs={24}>
          <Space align="">
            <p>آخرین بروزرسانی: </p>
            {updatedAt}
          </Space>
        </Col>
      </Row>
      <SideIncomesForm
        formData={formData}
        incomeId={id}
        onDoUpdateData={onDataUpdate}
      />
    </>
  );
}

export default SideIncomesTableDetails;
